import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const Partners = () => {
  const partList = [
    {
      one: "/images/part1.webp",
      two: "/images/part20.webp",
      three: "/images/part9.webp",
    },
    {
      one: "/images/part2.webp",
      two: "/images/part19.webp",
      three: "/images/part10.webp",
    },
    {
      one: "/images/part3.webp",
      two: "/images/part18.webp",
      three: "/images/part11.webp",
    },
    {
      one: "/images/part4.webp",
      two: "/images/part17.svg",
      three: "/images/part8.svg",
    },
    {
      one: "/images/part5.webp",
      two: "/images/part16.webp",
      three: "/images/part12.webp",
    },
    {
      one: "/images/part6.webp",
      two: "/images/part15.webp",
      three: "/images/part7.webp",
    },
    {
      one: "/images/part7.webp",
      two: "/images/part14.webp",
      three: "/images/part20.webp",
    },
    {
      one: "/images/part8.svg",
      two: "/images/part13.webp",
      three: "/images/part3.webp",
    },
    {
      one: "/images/part10.webp",
      two: "/images/part12.webp",
      three: "/images/part16.webp",
    },
    {
      one: "/images/part11.webp",
      two: "/images/part1.webp",
      three: "/images/part5.webp",
    },
  ];

  const [count, setCount] = useState(0);

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setCount(8);
    } else {
      setCount(2);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 768) {
        setCount(8);
      } else {
        setCount(2);
      }
    });
  }, []);

  return (
    <div id="partners" className="relative w-full h-full py-14 lg:py-28">
      <div
        data-aos="fade-up"
        id="title"
        className="relative w-full h-fit px-[calc((100%-var(--container))/2)]"
      >
        <div className="relative w-full h-fit flex justify-center items-end flex-nowrap sm:flex-wrap gap-3">
          <div className="relative w-fit h-full">
            <img
              className="!relative w-auto lg:w-full h-full max-h-9 lg:max-h-11 xl:max-h-14 lg:pb-1 object-contain"
              alt="비우고 채우고 로고"
              src="/images/logo.webp"
              loading="lazy"
              width={433}
              height={82}
            />
          </div>
          <h2 className="-mb-1.5 md:-mb-1">파트너사</h2>
        </div>
      </div>
      <div className=" relative w-full h-full py-10">
        {count > 0 && (
          <Swiper
            spaceBetween={30}
            centeredSlides={false}
            loop={true}
            slidesPerView={count}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={5000}
            loopAdditionalSlides={1}
            mousewheel={false}
            simulateTouch={false}
            allowTouchMove={false}
            grabCursor={false}
            modules={[Autoplay]}
            className="mySwiper swiper-wrapper relative w-full h-full mb-5"
          >
            {partList.map((v, i) => (
              <SwiperSlide
                key={i}
                className=" relative w-full h-full overflow-hidden"
              >
                <div className="relative w-full h-full border px-3 py-6">
                  <img
                    className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                    alt="비우고 채우고 협력 파트너사 로고"
                    src={v.one}
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </div>
                <div className="relative w-full h-full border px-3 py-6 my-5">
                  <img
                    className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                    alt="비우고 채우고 협력 파트너사 로고"
                    src={v.two}
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </div>
                <div className="relative w-full h-full border px-3 py-6">
                  <img
                    className="!relative w-auto max-w-20 h-8 lg:max-w-32 lg:h-14 mx-auto object-contain"
                    alt="비우고 채우고 협력 파트너사 로고"
                    src={v.three}
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default Partners;
